import { render, staticRenderFns } from "./Cardapio.vue?vue&type=template&id=09728954&scoped=true"
import script from "./Cardapio.vue?vue&type=script&lang=js"
export * from "./Cardapio.vue?vue&type=script&lang=js"
import style0 from "./Cardapio.vue?vue&type=style&index=0&id=09728954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09728954",
  null
  
)

export default component.exports